import React from "react";

function Projects() {
  const projects = [
    {
      title: "Youth Empowerment Program",
      description: "Equipping young people with leadership skills and mentorship.",
      image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&auto=format&fit=crop&q=60"
    },
    {
      title: "Community Outreach",
      description: "Supporting schools and communities with essential resources.",
      image: "https://images.unsplash.com/photo-1509099836639-18ba1795216d?w=600&auto=format&fit=crop&q=60"
    },
    {
      title: "Education Initiative",
      description: "Advocating and providing access to quality education.",
      image: "https://images.unsplash.com/photo-1588072432836-e10032774350?w=600&auto=format&fit=crop&q=60"
    }
  ];

  return (
    <section id="projects" style={styles.container}>
      <h2 style={styles.heading} data-aos="fade-up">
        Our Projects
      </h2>

      <div style={styles.grid}>
        {projects.map((project, index) => (
          <div
            key={index}
            style={styles.card}
            data-aos="zoom-in" // ✅ ADDED ANIMATION
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.05)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "scale(1)")
            }
          >
            <img
              src={project.image}
              alt={project.title}
              style={styles.image}
              loading="lazy" // ✅ ADDED PERFORMANCE FIX
            />

            <h3>{project.title}</h3>
            <p>{project.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

const styles = {
  container: {
    padding: "60px 20px",
    background: "#ffffff",
    textAlign: "center"
  },
  heading: {
    marginBottom: "40px"
  },
  grid: {
    display: "flex",
    gap: "20px",
    justifyContent: "center",
    flexWrap: "wrap"
  },
  card: {
    background: "white",
    padding: "25px",
    width: "280px",
    borderRadius: "15px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
    transition: "0.3s"
  },
  image: {
    width: "100%",
    height: "160px",
    objectFit: "cover",
    borderRadius: "10px"
  }
};

export default Projects;
